const teamId = localStorage.getItem('team_id');
const isAdmin = teamId === 'gale-force-ai-01-14478acd';
const isAmericanFinance = teamId === 'american-finance-01-41f43c80';
const isTracir = teamId === 'tracir-01-6f42ee20';

const Menu = [
	{ is_header: true, title: 'Navigation' },
	
    ...(isAdmin
        ? [
            { path: '/aicrm', icon: 'bi bi-cash-coin', title: 'AI CRM' },
            { path: '/artemisai', icon: 'bi bi-heart-arrow', title: 'Artemis AI' },
            { path: '/dealerrehash', icon: 'bi bi-car-front', title: 'Dealer Rehash' },
            { path: '/chat/usarmy', icon: 'bi bi-lightbulb', title: 'Subject Matter AI' },
            { path: '/redflagai', icon: 'bi bi-flag', title: 'Red Flag AI' },
			// { path: '/settings', icon: 'bi bi-gear', title: 'Settings' }
        ]
        : []
    ),
    
    ...(isAdmin || isAmericanFinance
        ? [
            { path: '/loanverification/dealerfiles', icon: 'bi bi-flag', title: 'Loan Verification' }
        ]
        : []
    ),

    ...(isAdmin || isTracir
        ? [
            // { path: '/tracir/bureaudata', icon: 'bi bi-car-front', title: 'Tracir Bureau Data' },
            { path: '/aiqueryagent', icon: 'bi bi-car-front', title: 'Tracir Reporting Database' }
        ]
        : []
    ),
	
	  // { path: '/settings', icon: 'bi bi-gear', title: 'Settings' }
];

if (window.location.pathname.includes('/loanverification') && !isAmericanFinance && !isAdmin) {
    window.location.href = '/';
    console.log("Unauthorized access attempt to Loan Verification redirected");
} else if (window.location.pathname.includes('/tracir') && !isTracir && !isAdmin) {
    window.location.href = '/';
    console.log("Unauthorized access attempt to Tracir Bureau Data redirected");
}
  
export default Menu;